import { onMount } from "svelte";
import { on } from "svelte/events";
import type { CinemaItemHTMLElement } from "./observer";

/**
 *
 *
 *
 *
 *
 */
export const useFocusInHandler = (Host: CinemaItemHTMLElement): void => {
  onMount(() =>
    on(Host, "focusin", (event) => {
      const item = event.target as CinemaItemHTMLElement | null;

      let isKeyboardUser = false;

      /*                                                          */
      /*                                                                                            */
      on(document, "keydown", () => {
        isKeyboardUser = true;
      });
      on(document, "mousedown", () => {
        isKeyboardUser = false;
      });

      if (item instanceof HTMLElement && isKeyboardUser && !item.isVisible) {
        item.scrollIntoView({ inline: "center", block: "nearest" });
      }
    }),
  );
};
